import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import RmunitFilterCriteria from './RmunitFilterCriteria'
import RmunitList from './RmunitList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './RmunitAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setRmunitDashboardRmunitList } from '../../store/slice/PharmaSlice';

export default function RmunitListView({setShowEdit,setRmunitId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.rmunitDashboard);   

    const [filteredRmunitList, setFilteredRmunitList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { rmunitDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (rmunitDashboard.rmunitList.length>-1){
        setFilteredRmunitList(rmunitDashboard.rmunitList);
        transformToCardFormat(rmunitDashboard.rmunitList, setCardList);
      }
    },[rmunitDashboard.rmunitList])

    useEffect(()=>{
          transformToCardFormat(filteredRmunitList, setCardList);
      },[filteredRmunitList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredRmunitList(rmunitDashboard.rmunitList);
            transformToCardFormat(rmunitDashboard.rmunitList, setCardList);

        } else {
            setFilteredRmunitList(
                rmunitDashboard.rmunitList
                    .filter(rmunit=> rmunit.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(rmunitDashboard.filteredRmunitList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <RmunitList
                    setShowEdit={setShowEdit}
                    setRmunitId = {setRmunitId}
                    tableList={filteredRmunitList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}